import React from 'react';
import Cookies from 'js-cookie';
import plus from './../assets/images/plus.svg'
import minus from './../assets/images/minus.svg'
import Sorting from './Sorting';


//public version display component
export default class PublicVersion extends React.Component {
  state = {
    error: '',
    publicVersion: [],
    actualData: [],
    version: [],
    selectedVersion: '',
    sortingStatus: {
      sortingName: '',
      defaultDown:  true
    },

  }
  componentWillMount() {
    this.fetchPublicVersion();
    console.log(process.env)
  }

  fetchPublicVersion = () => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/okasVersionApi/', {
      method: "GET",
      headers: headers,
    })
               .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
      .then(data => {
        if (data.detail === 'Invalid token.') {
          localStorage.clear();
        } else {
          this.setState({
            publicVersion: data,
            actualData: data
          })
        }
      })
      .catch((err)=>{
        console.log(err)
      })
  }


  versionDataMajor = () => {
    let element = this.state.publicVersion.map((e, index) => {
      const releaseDate = new Date(e.major.release_date * 1000);
      return <React.Fragment>
        <tr style={{ backgroundColor: this.state.selectedVersion === index ? '#f1f2e9' : '' }}>
          <td style={{ width: '5%' }}>
            <img src={this.state.selectedVersion === index ? minus : plus} style={{ verticalAlign: 'middle', marginLeft: '10px', cursor: 'pointer' }}
              onClick={(e) => {
                if (this.state.selectedVersion === index) {
                  this.setState({
                    selectedVersion: ''
                  })
                } else {
                  this.setState({
                    selectedVersion: index
                  })
                }
              }}
            />
          </td>
          <td style={{ width: '15%', fontSize:'12px' }}>{e.major.okas_full_version}</td>
          <td style={{ width: '15%', fontSize:'12px' }}>{e.major.okas_product_version}</td>
          <td style={{ width: '20%', fontSize:'12px' }}>{releaseDate.toString()}</td>
          <td style={{ width: '120px', fontSize:'12px' }}>
          <a rel="stylesheet" style={{color: '#00AEA7' }}
          onClick={() => {
            let firstPath = window.location.origin + '/';
            if(process.env.NODE_ENV==="development"){                
              window.open("http://192.168.0.49:8007/"+e.major.file+".pdf")
            }else{
             window.open(firstPath + e.major.file+".pdf")
            }
          }
            }
             /*href={e.major.file+".pdf"}*/>View</a>
          </td>
          <td style={{ width: '35%',  whiteSpace: 'pre-wrap', fontSize:'12px' }}>{e.major.release_note}</td>
        </tr>
        {this.state.selectedVersion === index ? this.versionDataMinor(e.minor) : null}
      </React.Fragment>
    })
    return element

  }

  versionDataMinor = (minor) => {
    return <tr style={{ margin: '30px 0px 30px 0px', borderTopStyle: 'solid', borderTopColor: '#E9E9F0', borderTopWidth: '2px', width: 'auto' }}>
      <tr style={{ backgroundColor: '#F1F2E9', fontWeight: 'bold' }}>
      <td style={{ width: '5%' }}></td>
        <td  style={{ width: '15%', fontSize:'12px' }}>APPLICATION NAME</td>
        <td  style={{ width: '15%', fontSize:'12px' }} >APPLICATION VERSION</td>
        <td  style={{ width: '20%', fontSize:'12px' }}>RELEASE DATE AND TIME</td>
        <td   style={{ width: '120px', fontSize:'12px' }}>ATTACHMENT</td>
        <td  style={{ width: '35%', fontSize:'12px' }}>RELEASE NOTES</td>
      </tr>
      {minor.map((e) => {
        const releaseDate = new Date(e.release_date * 1000);
        return (<tr style={{ backgroundColor: '#F1F2E9' }}>
        <td  style={{ width: '5%' }}></td>
          <td  style={{ width: '15%' }}>{e.application_name}</td>
          <td  style={{ width: '15%' }}>
            <span style={{fontWeight: 'bold'}}>
              {e.application_version.slice(0, 3)}
            </span>
            <span>
            {e.application_version.slice(3) }
            </span>
          </td>
          <td  style={{ width: '20%' }}>{releaseDate.toString()}</td>
          <td style={{width: '120px'}}>
          <a rel="stylesheet" style={{color: '#00AEA7' }}
          onClick={() => {
            let firstPath = window.location.origin + '/';
            console.log(process.env)
            if(process.env.NODE_ENV==="development"){
              window.open("http://192.168.0.49:8007/"+e.file+".pdf")
            }else{
              window.open(firstPath + e.file+".pdf")
            }
          }
          }
             /*href={e.major.file+".pdf"}*/
             >View</a>
          </td>
          <td style={{width: '35%',
           whiteSpace: 'pre-wrap'
           }}>{e.release_note}</td>
        </tr>
        )
      })}
    </tr>
  }

  restoreData = (data) => {
    this.setState({
      publicVersion: data,     
    })
  }

  sortingFunc = (type, searchValue) => {
    if (type !== 'search') {
      if(this.state.sortingStatus.sortingName===type){
      this.setState({
        sortingStatus: {
          sortingName: type,
          defaultDown:  !this.state.sortingStatus.defaultDown
        },
      },()=>{
        if(this.state.sortingStatus.sortingName===type && this.state.sortingStatus.defaultDown){
          Sorting(this.restoreData, type, this.state.actualData);      
        }else if(this.state.sortingStatus.sortingName===type && !this.state.sortingStatus.defaultDown){
          Sorting(this.restoreData, 'reverse', this.state.publicVersion);  
        }
      })
    }else{
      this.setState({
        sortingStatus: {
          sortingName: type,
          defaultDown:  true
        },
      },()=>{
        if(this.state.sortingStatus.sortingName===type && this.state.sortingStatus.defaultDown){
          Sorting(this.restoreData, 'reverse', this.state.actualData);      
        }else if(this.state.sortingStatus.sortingName===type && !this.state.sortingStatus.defaultDown){
          Sorting(this.restoreData, 'reverse', this.state.publicVersion);  
        }
      })
      }
    } else if (type === 'search') {
      type = 'search';
      Sorting(this.restoreData, type, this.state.actualData, searchValue);
    } else {
      type = 'reverse';
      Sorting(this.restoreData, type, this.state.actualData);
    }


  }


  fetchIconType = (e) =>{
    if(e===this.state.sortingStatus.sortingName && this.state.sortingStatus.defaultDown){
      return 'fas fa-chevron-down pointer ml-2 float-right'
    }else if(e===this.state.sortingStatus.sortingName && !this.state.sortingStatus.defaultDown){
      return 'fas fa-chevron-up pointer ml-2 float-right'
    }else{
      return 'fas fa-chevron-down pointer ml-2 float-right icon-inactive'
    }
  }


  render() {
    return (
      <React.Fragment>
        <div style={{ width: '100%', paddingLeft: '90px', paddingTop: '40px', paddingRight: '90px' }}>
          <div style={{ marginBottom: '20px' }}>
            <span style={{ color: '#888888', fontSize: '30px', }} className="text-uppercase">Version Control: Public</span>
          </div>
          <table className="table">
            <thead className="tableHeaderColor" style={{ borderRadius: '10px 10px 0px 0px' }}>
              <th scope="col" style={{ width: '5%' }}>
              <i className="fas fa-chevron-down" style={{verticalAlign: 'middle', marginLeft: '12px' }}></i>
              </th>
              <th scope="col" style={{ width: '15%', fontSize:'12px' }}>
              Full Version
              <i class={this.fetchIconType('full_version')} onClick={(e) => { this.sortingFunc('full_version') }} >
                </i>
              </th>
              <th scope="col" style={{ width: '15%', fontSize:'12px' }}>
              Public Version        
              <i class={this.fetchIconType('public_version')} onClick={(e) => { this.sortingFunc('public_version') }} >
                </i>  
              </th>
              <th scope="col" style={{ width: '20%', fontSize:'12px' }}>
              Release Date & Time
              <i class={this.fetchIconType('date')} onClick={(e) => { this.sortingFunc('date') }} >
                </i>  
              </th>
              <th scope="col"  style={{width: '120px', fontSize:'12px'}}> Attachment</th>
              <th scope="col" style={{ width: '35%', fontSize:'12px' }}>
              Release Notes
             </th>
            </thead>
            <tbody style={{ maxHeight: `${window.innerHeight - 250}px`, overflowY: 'overlay', height: 'auto', backgroundColor: "#F1F2E9" }}>
              {this.versionDataMajor()}
            </tbody>
          </table>
        </div>

      </React.Fragment>
    )
  }
}